import { Component, OnInit } from '@angular/core';
import { ModalContainerService, BaseModalUpdateComponent, ModalService } from 'yt-ng-framework';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { VrstaTelefona } from './vrsta-telefona';

@Component({
  selector: 'app-vrsta-telefona-modal-update',
  templateUrl: './vrsta-telefona-modal-update.component.html'  
})
export class VrstaTelefonaModalUpdateComponent extends BaseModalUpdateComponent<VrstaTelefona> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<VrstaTelefona>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService
  ) 
  {
    super(modalContainerService, activeModal,modalService);
  }

  ngOnInit() {
  }

}
